import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Button } from './ui/Button';
const CALENDAR_URL = 'https://calendar.app.google/PYPdcRoYne7QrNJA7';
export function Hero() {
  const painPoints = ['Si en días de semana el restaurante está vacío aunque el fin de semana esté lleno', 'Si dependes de que la gente "pase por enfrente" para entrar', 'Si tus promociones de descuento atraen gente que gasta poco y no vuelve sin otro descuento', 'Si no tienes un sistema de reservas online y las mesas se quedan vacías', 'Si tu competencia aparece primero en Google Maps y en Yelp aunque tu comida sea mejor'];
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 border-b border-gray-900" data-id="element-21">
      <div className="max-w-4xl mx-auto" data-id="element-22">
        <div className="text-center mb-12" data-id="element-23">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-24">
            ¿Tu restaurante tiene mesas vacías{' '}
            <br className="hidden md:block" data-id="element-25" />
            mientras el de enfrente{' '}
            <span className="text-gold" data-id="element-26">tiene lista de espera?</span>
          </h1>
          <p className="text-lg md:text-xl text-gray-400 max-w-3xl mx-auto leading-relaxed" data-id="element-27">
            No es la comida. Es el sistema. Llenamos tu restaurante de
            comensales que reservan con anticipación, gastan más por visita y
            regresan una y otra vez.
          </p>
        </div>

        <div className="bg-gray-900/30 border border-gray-800 p-6 md:p-8 rounded-sm mb-12" data-id="element-28">
          <p className="text-sm font-semibold text-gray-500 uppercase tracking-wider mb-6" data-id="element-29">
            Identifica tu situación:
          </p>
          <ul className="space-y-4" data-id="element-30">
            {painPoints.map((point, index) => <li key={index} className="flex items-start" data-id="element-31">
                <CheckCircle2 className="w-6 h-6 text-emerald shrink-0 mr-4 mt-0.5" data-id="element-32" />
                <span className="text-gray-300 text-base md:text-lg" data-id="element-33">
                  {point}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="flex justify-center" data-id="element-34">
          <Button href={CALENDAR_URL} className="w-full md:w-auto shadow-[0_0_30px_rgba(242,183,5,0.15)]" data-id="element-35">
            QUIERO MI RESTAURANTE LLENO
          </Button>
        </div>
      </div>
    </section>;
}